// Styles for SkeletonLoader go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledSkeletonLoader = styled.div`
  .list-view-skeleton-card-row {
    @media only ${baseVariables.mediaQuery.md} {
      gap: 0 ${toRem(24)};
    }
  }

  .list-view-skeleton-card-row > [class*='col-'] {
    flex: 0 0 auto;
    width: ${toRem(343)};
    max-width: ${toRem(343)};
    box-sizing: border-box;

    @media only ${baseVariables.mediaQuery.md} {
      width: ${toRem(348)};
      max-width: ${toRem(348)};
    }
    @media only ${baseVariables.mediaQuery.xl} {
      width: ${toRem(364)};
      max-width: ${toRem(364)};
    }
  }

  .list-card-skeleton-divider {
    display: block;
    width: 100%;
    height: ${toRem(1)};
    margin: ${toRem(16)} 0 ${toRem(20)};
    border: 0;
    background-color: ${baseVariables.color['neutral30']};
    opacity: 1;
  }

  .image-place-loader {
    flex-shrink: 0;
    margin-right: ${toRem(16)};
    height: ${toRem(96)};
    width: ${toRem(96)};
    border-radius: ${toRem(4)};
  }

  .skeleton-el.react-loading-skeleton {
    border-radius: unset;
  }
`;
